import { render } from "./SetIntake.vue?vue&type=template&id=54082585"
import script from "./SetIntake.vue?vue&type=script&lang=ts"
export * from "./SetIntake.vue?vue&type=script&lang=ts"
script.render = render

export default script